<template>
  <div class="join">
    <utopa-title :title="showData.title">
    </utopa-title>
    <div class="join-imgs">
      <img @click.prevent
           v-for="(img,index) in showData.imgs"
           :key="index"
           :src="img.img"
           width="100%">
    </div>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例
import utopaTitle from 'components/title.vue'
export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      CN: {
        title: '人才招聘',
        imgs: [
          { img: require('images/join/img1.jpg') },
          { img: require('images/join/img2.jpg') },
          { img: require('images/join/img3.jpg') },
          { img: require('images/join/img4.jpg') },
          { img: require('images/join/img5.jpg') },
          { img: require('images/join/img6.jpg') },
          { img: require('images/join/img7.jpg') },
          { img: require('images/join/img9.jpg') },
          { img: require('images/join/img10.jpg') },
          { img: require('images/join/img11.jpg') },
          { img: require('images/join/img12.jpg') },
          { img: require('images/join/img13.jpg') },
          { img: require('images/join/img14.jpg') }
        ]
      },
      ZH: {
        title: '人才招聘',
        imgs: [
          { img: require('pcImg/page6/1.jpeg') },
          { img: require('pcImg/page6/2.jpeg') },
          { img: require('pcImg/page6/3.jpeg') },
          { img: require('pcImg/page6/4.jpeg') },
          { img: require('pcImg/page6/5.jpeg') },
          { img: require('pcImg/page6/6.jpeg') },
          { img: require('pcImg/page6/7.jpeg') },
          { img: require('pcImg/page6/9.jpeg') },
          { img: require('pcImg/page6/10.jpeg') },
          { img: require('pcImg/page6/11.jpeg') },
          { img: require('pcImg/page6/12.jpeg') },
          { img: require('pcImg/page6/13.jpeg') },
          { img: require('pcImg/page6/14.jpeg') }
        ]
      }
    }
  },
  components: { utopaTitle },
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.join {
  padding-top: px2rem(54);
  &-imgs {
    font-size: 0;
    margin-top: px2rem(20);
  }
}
</style>
